module.exports = __webpack_public_path__ + "static/media/featureImg1.804f51a1.png";